<template>
  <div class="page-container page-customType">
    <div class="operations">
        <div class="operation-btns">
            <div @click="goAdd">+新建模板</div>
        </div>
    </div>

    <!--TABLE-->
    <el-table
        :data="tableData"
        border
        tooltip-effect="dark"
        style="width: 100%;"
       >
    <!-- <el-table-column label="序号"
            type="index"
            width="50">
    </el-table-column> -->

    <el-table-column
            prop="modelName"
            align="center"
            label="产品型号"
            >
    </el-table-column>
    <el-table-column
            prop="createTime"
            align="center"
            label="创建时间"
            >
    </el-table-column>
    <el-table-column
            label="操作"
            align="center"
            width="200">
        <template slot-scope="scope">
            <div style="text-align: center;">
                 <el-button class="checkCard" type="text" size="medium" @click="goEdit(scope.row)">一键复制</el-button>
                <el-button class="checkCard" type="text" size="medium" @click="handleDel(scope.row)">删除</el-button>
            </div>
        </template>
    </el-table-column>
</el-table>
<div class="page">
    <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="pageNum"
            :page-sizes="[10]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
    </el-pagination>
</div>
  </div>
</template>
<script>
import {  fetchDataModelList, fetchDelDataModel } from '@/api/customPage.js';
export default {
    data() {
        return {
          pageNum: 1,
          pageSize: 10,
          total: 0,
          tableData: [],
        };
    },
    created() {

    },
    mounted() {
      this.init()
    },
    methods: {
        init() {
          let params = {
            companyId: JSON.parse(localStorage.getItem('info')).companyId,
            pageNum: this.pageNum,
            pageSize: this.pageSize,
          }
          fetchDataModelList(params).then(res => {
            if(res.code === 200) {
              this.tableData = res.data.list
              this.total = res.data.total
            }
          })
        },
        handleCurrentChange (page) {
          this.pageNum = page
          this.init()
        },
        goAdd() {
           this.$router.push({path: "/mkc/configHandleTypeAdd", query: {modeType: 'add'}});
        },
        goEdit(row) {
           this.$router.push({path: "/mkc/configHandleTypeAdd", query: {modeType: 'copy', id: row.id, modelName: row.modelName}});
        },
        handleDel(row) {
          this.$confirm('确认要删除吗?', '提示', {
            //type: 'warning'
          }).then(() => {
            // console.log('确认')
            let params = {
              id: row.id
            }
            fetchDelDataModel(params).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: "删除成功",
                  type: "success",
                });
              }
              this.init()
            })
          }).catch(() => {
            console.log('取消')
          });
        }
    }
}
</script>
<style scoped lang="scss">
.page-container{
  background: #fff;
}

.operations{
            display: flex;
            justify-content: space-between;
            height: 60px;
            align-items: center;
            .operation-btns{
                display: flex;
                div{
                    border-radius: 4px;
                    // background: #B9EBEA;
                    background: #51CDCB;
                    font-size: 14px;
                    line-height: 30px;
                    height: 30px;
                    color: #fff;
                    padding: 0 20px;
                    margin-right: 10px;
                    cursor: pointer;
                }
                .disabled{
                    background: #B9EBEA;
                }
            }
            .search-user{
                display: flex;
                .search-input{
                    height: 30px;
                    margin-right: 10px;
                    .el-input__inner{
                        height: 30px;
                    }
                }
                .search-btn{
                    border-radius: 4px;
                    // background: #B9EBEA;
                    background: #51CDCB;
                    font-size: 14px;
                    line-height: 30px;
                    height: 30px;
                    color: #fff;
                    padding: 0 20px;
                    cursor: pointer;
                }
                .disabled{
                    background: #B9EBEA;
                }
            }
        }
</style>
